import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate  } from "react-router-dom";
import WspolnotyWazneNumeryDodaj from "./WspolnotyWazneNumeryDodaj";
import WspolnotyWazneNumeryLista from "./WspolnotyWazneNumeryLista";

const WspolnotyWazneNumery = props => {

    const {wspolnota, wazneNumery } = props;

    const [activeWindow, setActiveWindow] = useState("lista");

    const page = () => {
        switch(activeWindow) {
            case "lista":
                return (   
                    <WspolnotyWazneNumeryLista
                        wazneNumery={wazneNumery}
                        setActiveWindow={setActiveWindow}
                        idw={wspolnota?.id}
                    /> );
            case "dodaj":
                return (
                    <WspolnotyWazneNumeryDodaj
                        idw={wspolnota?.id}
                        setActiveWindow={setActiveWindow}
                    />
                );
            default: return (<Fragment></Fragment>);
        }
    }

    return (
        <div className="ramka wspolnotyWazneNumery ">
            {page()}
        </div>
    )
}

export default WspolnotyWazneNumery;